export const Card = ({ title, children, className = '' }) => (
  <div className={`bg-white p-6 rounded-xl shadow-xl border border-gray-100 ${className}`}>
    <h3 className="text-2xl font-extrabold mb-4 text-gray-800 border-b pb-2 border-indigo-100">{title}</h3>
    {children}
  </div>
);